export const InvoiceCard = {
  flow: 'y',
  gap: 'Z',
  padding: 'B',
  round: 'Z',
  background: 'inkMid',
  border: '1px solid inkBorder',

  HeaderRow: {
    flow: 'x',
    align: 'center flex-start',
    justifyContent: 'space-between',
    InvoiceNumber: { text: (el, s) => s.invoiceNumber || '', fontSize: 'Z', fontWeight: '700', color: 'inkText' },
    InvoiceStatus: {
      tag: 'span',
      text: (el, s) => s.invoiceStatus || '',
      fontSize: 'Y',
      fontWeight: '600',
      padding: 'X Z',
      round: 'B',
      background: (el, s) => {
        const st = s.invoiceStatus
        if (st === 'Draft') return 'inkSurface'
        if (st === 'Sent') return 'blue.15'
        if (st === 'Paid') return 'green.15'
        if (st === 'Overdue') return 'red.15'
        return 'inkSurface'
      },
      color: (el, s) => {
        const st = s.invoiceStatus
        if (st === 'Draft') return 'inkMuted'
        if (st === 'Sent') return 'blue'
        if (st === 'Paid') return 'green'
        if (st === 'Overdue') return 'red'
        return 'inkMuted'
      }
    }
  },

  PatientName: { text: (el, s) => s.patientName || '', fontSize: 'Z', color: 'inkText', fontWeight: '600' },
  InvoiceDate: { text: (el, s) => s.invoiceDate ? `{{ date | polyglot }}: ${s.invoiceDate}` : '', fontSize: 'Y', color: 'inkMuted' },

  Divider: { height: '1px', background: 'inkBorder' },

  ProcedureList: {
    flow: 'y',
    gap: 'Y',
    ProcedureListLabel: { text: '{{ procedures | polyglot }}', fontSize: 'Y', color: 'inkMuted', fontWeight: '600', textTransform: 'uppercase', letterSpacing: 'X', marginBottom: 'X' },
    Items: {
      flow: 'y',
      gap: 'X',
      children: (el, s) => (s.procedures || []).map(proc => ({
        name: proc.name,
        cost: proc.cost
      })),
      childrenAs: 'state',
      childExtends: 'InvoiceProcedureItem'
    }
  },

  Divider2: { height: '1px', background: 'inkBorder' },

  TotalRow: {
    flow: 'x',
    justifyContent: 'space-between',
    align: 'center flex-start',
    Label: { text: '{{ total | polyglot }}', fontSize: 'Z', fontWeight: '700', color: 'inkText' },
    Value: { text: (el, s) => s.totalAmount || '', fontSize: 'A', fontWeight: '800', color: 'inkText' }
  },

  ActionsRow: {
    flow: 'x',
    gap: 'Y',
    marginTop: 'Y',
    SendBtn: { tag: 'button', text: '{{ send | polyglot }}', padding: 'Y Z', round: 'A', background: 'teal', color: 'ink', fontSize: 'Y', fontWeight: '600', cursor: 'pointer', border: 'none' },
    PrintBtn: { tag: 'button', text: '{{ print | polyglot }}', padding: 'Y Z', round: 'A', background: 'inkSurface', color: 'inkMuted', fontSize: 'Y', fontWeight: '600', cursor: 'pointer', border: 'none' },
    DownloadBtn: { tag: 'button', text: '{{ download | polyglot }}', padding: 'Y Z', round: 'A', background: 'inkSurface', color: 'inkMuted', fontSize: 'Y', fontWeight: '600', cursor: 'pointer', border: 'none' }
  }
}

export const InvoiceProcedureItem = {
  flow: 'x',
  justifyContent: 'space-between',
  align: 'center flex-start',
  padding: 'Y 0',
  ProcName: { text: (el, s) => s.name || '', fontSize: 'Y', color: 'inkText' },
  ProcCost: { text: (el, s) => s.cost || '', fontSize: 'Y', fontWeight: '600', color: 'inkText' }
}
